var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagnation_box fc"},[(_vm.totalPage)?_c('span',{staticStyle:{"margin-right":"20px"}},[_vm._v("共"+_vm._s(_vm.totalPage)+"页")]):_vm._e(),_c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next","current-page":_vm.currentPage,"page-size":_vm.pageSize,"total":_vm.total},on:{"current-change":_vm.pagChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }